import PrimaryDataCard from './PrimaryDataCard'
import RecentNotesCard from './RecentNotesCard'
import GoalsCard from './GoalsCard'
import ResearchCard from './ResearchCard'
import PersonaEffects from './PersonaEffects'
import StatusHistoryCard from '../../statusHistory/StatusHistoryCard'
import Location from '../../../hooks/Location'

const PersonaDashboard = ({ personaNavigation, item }) => {
    const personaId = Location()[3]

    return (
        <div className={`persona-dashboard ${personaNavigation === 'dashboard' ? '' : 'persona-dashboard-hidden'}`}>
            <div className="new-dashboard-grid">
                <PrimaryDataCard />
                <RecentNotesCard />
                <GoalsCard />
                <ResearchCard item={item} />
                <StatusHistoryCard entityType="persona" entityID={personaId} />
                {/* Mounted only when the tab is visible — its Firestore listeners
                    (OutputEffects, QuestionnaireFields, persona responses) would
                    otherwise stream all session behind the CSS-hidden dashboard. */}
                {personaNavigation === 'dashboard' && <PersonaEffects item={item} />}
            </div>
        </div>
    )
}

export default PersonaDashboard
